export default {
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT,
  url: process.env.VUE_APP_KEYCLOAK_SERVER_URL,
};
